/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * 
 */
export type PrefferedChannelEnum = 0 | 1 | 2;

export const PrefferedChannelEnum = {
    NUMBER_0: 0 as PrefferedChannelEnum,
    NUMBER_1: 1 as PrefferedChannelEnum,
    NUMBER_2: 2 as PrefferedChannelEnum
};
